export default {
  MessageProvider__ERROR_DEFAULT:
    "We are unable to process your request. Please try again. If you continue to have difficulties, please contact a Southwest Airlines® Customer Representative at 1-800-I-FLY-SWA (1-800-435-9792).",
  MessageProvider__ERROR_DEFAULT_TITLE: "Sorry, we found some errors...",
  MessageProvider__ERROR_MULTIPLE_TITLE: "Sorry, we found some errors...",
};
